export default __webpack_public_path__ + "static/media/hht2_ep10_speaking_01.afd533e1.png";